<template>
  <div v-if="rows && rows.length" class="chart-overview">
    <vue-good-table
      :columns="columns"
      :rows="rows"
      styleClass="vgt-table" />
  </div>
</template>

<script>
  import { getResponseFromEntryPoint, createInfoServiceParams, linkEntryPoints } from '@/rest/restClient.js'
  export default {
    name: 'chart-overview',
    props: {
      articleNo: {
        type: String,
        required: true
      },
      serialNo: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        columns: [
          {
            label: this.$t('hs.att-dashboard.frequency-range'),
            field: 'freqRange',
            width: '28%'
          },
          {
            label: this.$t('hs.att-dashboard.il-min-s21'),
            field: 'ilMinS21',
            type: 'number',
            width: '18%',
            formatFn: this.fixed3Number
          },
          {
            label: this.$t('hs.att-dashboard.il-min-s12'),
            field: 'ilMinS12',
            type: 'number',
            width: '18%',
            formatFn: this.fixed3Number
          },
          {
            label: this.$t('hs.att-dashboard.rl-max-s11'),
            field: 'rlMaxS11',
            type: 'number',
            width: '18%',
            formatFn: this.fixed3Number
          },
          {
            label: this.$t('hs.att-dashboard.rl-max-s22'),
            field: 'rlMaxS22',
            type: 'number',
            width: '18%',
            formatFn: this.fixed3Number
          }
        ],
        rows: []
      }
    },
    methods: {
      async fetchData () {
        const params = createInfoServiceParams(this.articleNo, this.serialNo)
        const overviewResponse = await getResponseFromEntryPoint(linkEntryPoints.itemOverviewService, params)
        if (!overviewResponse.error) {
          this.rows = overviewResponse.props.measurePoints
        } else {
          this.rows = []
        }
      },
      fixed3Number (value) {
        return value.toFixed(3)
      }
    },
    created () {
      if (this.articleNo && this.serialNo) {
        this.fetchData()
      }
      this.$watch(vm => [vm.articleNo, vm.serialNo].join(), this.fetchData)
    }
  }
</script>

<style lang="scss" scoped>
.chart-overview {
  padding-bottom: $component-padding;
}
</style>
